import styled from 'styled-components';
import { Row } from 'src/presentation/components/forms/Layout';

export const HalfRow = styled(Row)`
  width: 75%;
`;

export { Row };
